import { Component, OnInit } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeSr from '@angular/common/locales/sr';
import { TimeSlotConfiguration } from '../../models/timeSlotConfiguration';
import { Playroom } from '../../models/playroom.model';
import { TimeSlotConfigurationService } from '../../services/time-slot-configuration.service';
import { PlayroomService } from '../../services/playroom.service';
import { TimeSlotGenerationOutputDTO } from '../../models/timeSlotDTO';
import { CalendarWeek } from '../../models/CalendarWeek';
import { CalendarSlotState } from '../../models/CalendarSlotState';
import { CalendarSlotRange } from '../../models/CalendarSlotRange';
import { CalendarSaveGeneratedInput } from '../../models/CalendarSaveGeneratedInput';
import { TimeSlotGenerationDTO } from '../../models/TimeSlotGenerationDTO';
import { BirthdayZone } from '../../models/birthdayZone';

registerLocaleData(localeSr);

@Component({
  selector: 'app-time-slot-configuration',
  templateUrl: './time-slot-configuration.component.html',
  styleUrls: ['./time-slot-configuration.component.scss']
})
export class TimeSlotConfigurationComponent implements OnInit {
  config = new TimeSlotConfiguration();
  zones: BirthdayZone[] = [];
  playrooms: Playroom[] = [];
  generatedTimes: TimeSlotGenerationOutputDTO[] = [];
  calendarWeek: CalendarWeek | null = null;

  currentStartDate: Date = new Date();
  timeLabels: string[] = [];
  readonly state = CalendarSlotState;

  payload: any = null

  constructor(
    private timeSlotService: TimeSlotConfigurationService,
    private playroomService: PlayroomService
  ) { }

  ngOnInit(): void {
    this.playroomService.getAllPlayrooms();
    this.playroomService.playrooms$.subscribe(p => this.playrooms = p);

    this.currentStartDate = this.toMonday(new Date());
    this.timeLabels = this.buildTimeLabels();
  }

  onRoomChanged(): void {
    if (!this.config.roomId) {
      this.zones = [];
      this.config.birthdayZoneId = null;
      this.calendarWeek = null;
      return;
    }

    const room = this.playrooms.find(r => r.id === this.config.roomId);
    const roomName = room?.roomName ?? '';

    this.timeSlotService.getZonesByRoom(this.config.roomId, roomName).subscribe({
      next: zs => {
        this.zones = zs ?? [];
        this.config.birthdayZoneId = this.zones[0]?.id ?? null;
        this.loadWeekCalendar();
      },
      error: err => console.error(err)
    });
  }

  onFlexibleSlotChange(event: any) {
    if (this.config.flexibleTherms == true) {

      this.config.birthdateDuration = "0:30";
      this.config.pause = '0:00'
    }

  }

  loadWeekCalendar(): void {
    if (!this.config.roomId) return;
    this.timeSlotService
      .getWeekCalendar(this.currentStartDate, this.config.roomId, this.config.birthdayZoneId ?? undefined)
      .subscribe({
        next: wc => this.calendarWeek = wc,
        error: err => console.error(err)
      });
  }

  onToday(): void {
    this.currentStartDate = this.toMonday(new Date());
    this.loadWeekCalendar();
  }

  prevWeek(): void {
    this.currentStartDate = new Date(this.currentStartDate.getTime());
    this.currentStartDate.setDate(this.currentStartDate.getDate() - 7);
    this.currentStartDate = this.toMonday(this.currentStartDate);
    this.loadWeekCalendar();
  }

  nextWeek(): void {
    this.currentStartDate = new Date(this.currentStartDate.getTime());
    this.currentStartDate.setDate(this.currentStartDate.getDate() + 7);
    this.currentStartDate = this.toMonday(this.currentStartDate);
    this.loadWeekCalendar();
  }

  onDateFromChanged(): void {
    if (!this.config.dateFrom) return;
    const d = new Date(this.config.dateFrom);
    this.currentStartDate = this.toMonday(d);
    this.loadWeekCalendar();
  }


  generateTimeSlots(): void {
    this.payload = this.buildGenerationPayload();
    if (!this.payload) return;
    this.timeSlotService
      .getCalendarWithAppointments(this.currentStartDate, this.payload.roomId!, this.payload.birthdayZoneId!)
      .subscribe({
        next: wc => {
          this.calendarWeek = wc,
          console.log("Booked Slots; Generate Method", this.calendarWeek)

          for (let i = 0; i < this.calendarWeek.days.length; i++) {
            if (this.calendarWeek.days[i].date >= this.payload.dateFrom && this.calendarWeek.days[i].date <= this.payload.dateTo) {

              const foundBooked = this.calendarWeek.days[i].slots
                .some(slot => slot.state === 2)
                ;
              if (foundBooked) {

                alert('Greška pri generisanju - u izabranom opsegu datuma nalazi se zakazani rođendan ');
                console.warn("Pronađen zauzet termin – prekid generisanja!");


                return;
              }

            }


          }

          this.timeSlotService.generateOverlay(this.payload).subscribe({
            next: wc => this.calendarWeek = wc,
            error: err => { console.error(err); alert('Greška pri generisanju (overlay).'); }
          });

          this.timeSlotService.generateTimeSlots(this.payload).subscribe({
            next: res => this.generatedTimes = res,
            error: err => { console.error(err); alert('Greška pri generisanju slotova.'); }
          });

        },

        error: err => console.error(err)
      });


  }

  save(): void {
    if (!this.config.roomId || !this.generatedTimes.length) {
      alert('Nema generisanih termina za snimanje.');
      return;
    }

    const ranges: CalendarSlotRange[] = [];
    for (const day of this.generatedTimes) {
      for (const s of day.slots) {
        const r = new CalendarSlotRange();
        r.start = s.start;
        r.end = s.end;
        ranges.push(r);
      }
    }

    const input = new CalendarSaveGeneratedInput();
    input.roomId = this.config.roomId;
    input.birthdayZoneId = this.config.birthdayZoneId as number;
    input.slots = ranges;
    input.isFlexible = this.config.flexibleTherms;
    input.payLoad = this.payload;

    console.log("Save input", input)
    this.timeSlotService.saveGenerated(input).subscribe({
      next: () => {

        this.resetForm();
        alert('Termini sačuvani.');
      },
      error: err => {
        console.error(err);
        alert('Greška pri snimanju termina.');
      }
    });
  }

  isToday(dateIso: string): boolean {
    const d = new Date(dateIso);
    const t = new Date();
    return d.getFullYear() === t.getFullYear()
      && d.getMonth() === t.getMonth()
      && d.getDate() === t.getDate();
  }

  private buildGenerationPayload(): TimeSlotGenerationDTO | null {
    if (!this.isFormValid()) { alert('Popunite sva polja.'); return null; }
    const date = this.extractDate(this.config.dateFrom);

    // Samo startTime i endTime konvertuj u UTC, dateFrom i dateTo ostaju kao lokalni datum
    const localStartTime = this.combineDateAndTime(date, this.config.startTime);
    const localEndTime = this.combineDateAndTime(date, this.config.endTime);

    return {
      dateFrom: this.toFullIsoDate(this.config.dateFrom),
      dateTo: this.toFullIsoDate(this.config.dateTo),
      startTime: this.toUtcIsoString(localStartTime),
      endTime: this.toUtcIsoString(localEndTime),
      birthdateDuration: this.normalizeTimeSpan(this.config.birthdateDuration),
      pause: this.normalizeTimeSpan(this.config.pause),
      roomId: this.config.roomId as number,
      birthdayZoneId: this.config.birthdayZoneId as number
    };
  }


  private toMonday(d: Date): Date {
    const date = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const day = date.getDay();
    const diff = (day === 0 ? -6 : 1 - day);
    date.setDate(date.getDate() + diff);
    return date;
  }

  private buildTimeLabels(): string[] {

    console.log('BUILDtIMELABELS')
    const res: string[] = [];
    for (let h = 9; h < 24; h++) {
      const hh = String(h).padStart(2, '0');
      res.push(`${hh}:00`);
      res.push(`${hh}:30`);
    }
    res.push('00:00');
    return res;

  }

  extractDate(dateTime: string): string {
    return dateTime?.split('T')[0] ?? '';
  }
  combineDateAndTime(date: string, time: string): string {
    return `${date}T${time?.length === 5 ? time + ':00' : time}`;
  }
  toFullIsoDate(date: string): string {
    return date?.includes('T') ? date : `${date}T00:00:00`;
  }
  normalizeTimeSpan(time: string): string {
    const [h = '00', m = '00', s = '00'] = (time ?? '').split(':');
    return `${h.padStart(2, '0')}:${m.padStart(2, '0')}:${s.padStart(2, '0')}`;
  }

  private toUtcIsoString(localDateTimeStr: string): string {
    // Parsira lokalni string kao lokalno vreme i konvertuje u pravi UTC
    const localDate = new Date(localDateTimeStr);
    return localDate.toISOString();
  }

  private fromUtcToLocal(utcDateStr: string): Date {
    // Ako string nema Z ili timezone, dodaj Z da označi UTC
    if (utcDateStr && !utcDateStr.endsWith('Z') && !/[+-]\d{2}:\d{2}$/.test(utcDateStr)) {
      utcDateStr = utcDateStr + 'Z';
    }
    return new Date(utcDateStr);
  }

  formatTo24h(value: string): string {
    if (/^\d{2}:\d{2}$/.test(value)) return value;
    const match = value?.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
    if (!match) return value;
    let [, hoursStr, minutes, period] = match;
    let hours = parseInt(hoursStr, 10);
    if (period.toUpperCase() === 'PM' && hours < 12) hours += 12;
    if (period.toUpperCase() === 'AM' && hours === 12) hours = 0;
    return `${String(hours).padStart(2, '0')}:${minutes}`;
  }
  formatTimeOnly(dateTime: string): string {
    const localDate = this.fromUtcToLocal(dateTime);
    return localDate.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hour12: false });
  }
  formatDateOnly(dateStr: string): string {
    const localDate = this.fromUtcToLocal(dateStr);
    return localDate.toLocaleDateString(undefined);
  }

  isFormValid(): boolean {
    return !!(
      this.config.roomId &&
      this.config.birthdayZoneId &&
      this.config.dateFrom &&
      this.config.dateTo &&
      this.config.startTime &&
      this.config.endTime &&
      this.config.birthdateDuration &&
      this.config.pause
    );
  }

  get monthYear(): string {
    if (!this.calendarWeek?.weekStart) return '';
    const d = new Date(this.calendarWeek.weekStart);
    return d.toLocaleDateString(undefined, { month: 'long', year: 'numeric' });
  }

  weekdaySrLatn(dateIso: string): string {
    const localDate = this.fromUtcToLocal(dateIso);
    return localDate.toLocaleDateString(undefined, { weekday: 'long' });
  }

  private resetForm(): void {
    this.config = new TimeSlotConfiguration();
    this.generatedTimes = [];
    this.calendarWeek = null;
  }

  private formatDateOnlyISO(d: Date): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }
}
